import React from "react";
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close'
import { Auth, I18n } from 'aws-amplify';
import {ENERGYMNTR_URL, PR_CONTENT_URL, TERM_VER, MIERUKA_MANUAL} from "../../../configures/val.js";
import MierukaPagenation from './mierukapagenation.js'
import authCheck, { getCruiseSetting, getMierukaIds } from '../../util/callApi.js';
import checkTermsVer from '../../util/checkTermsVer.js';
import LapDialog from '../../util/laplaceDialog.js';

// 0: 正常, 1: ロード中, 2: 正常通信だがデータがない, -1: 通信できてない
const API_STATUS = {
  OK: 0,
  LOADING: 1,
  NO_BODY: 2,
  NO_RESPONSE: -1
};

export default class MierukaManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authzDbError: API_STATUS.LOADING,
      cruiseSettingError: API_STATUS.LOADING,
      urlSnackState: false,
      snackMessage: '',
      termVerError: false,
    };
    this.contentsList = [];
  }
  async componentDidMount() {
    this._isMounted = true;
    try {
      const authRet = await authCheck();
      if (authRet.result === 'NG') {
        console.log('now Cruiseng == authCheck');
        window.history.pushState('', '', '/');
        this.props.authStateChange('signIn');
        return;
      } else {
        const isLowVer = checkTermsVer(authRet.data, 'custom:agreed_term', TERM_VER, 'ver');
        if (isLowVer) {
          this.setState({
            authzDbError: API_STATUS.LOADING,
            cruiseSettingError: API_STATUS.LOADING,
            termVerError: true,
            href: window.location
          });
          return;
        }
      }
      // これで管理画面の行を作る
      let mierukaWebIdsTmp = await getMierukaIds();
      if (mierukaWebIdsTmp.result === 'NG') {
        console.log('mierukawebIds can not get - authzdbapi');
        this.setState({
          authzDbError: API_STATUS.NO_RESPONSE,
          cruiseSettingError: API_STATUS.OK,
          termVerError: false
        });
        return;
      }
      const mierukaWebIds = mierukaWebIdsTmp.data.data["mieruka_web_ids"];
      if (mierukaWebIds.length === 0) {
        this.setState({
          authzDbError: API_STATUS.NO_BODY,
          cruiseSettingError: API_STATUS.OK,
          termVerError: false
        });
        return;
      }
      const tmpList = [];
      const cruiseSettings = {};
      for (let i = 0; i < mierukaWebIds.length; i++) {
        const queryStr = mierukaWebIds[i];
        cruiseSettings[queryStr] = await getCruiseSetting(queryStr);
        if (cruiseSettings[queryStr].result === 'NG') {
          // 1つでもエラーのときはNGで処理を終える
          this.setState({
            authzDbError: API_STATUS.OK,
            cruiseSettingError: API_STATUS.NO_RESPONSE,
            termVerError: false
          });
          return;
        } else {
          const url = PR_CONTENT_URL + queryStr;
          let isPremium = false;
          let titleStr = cruiseSettings[queryStr].data.data.config.screens[0].title; // verが2のとき、isPremiumがtrueのときはtitle要素を使う
          if (cruiseSettings[queryStr].data.data.config.hasOwnProperty('premium')) {
             isPremium = cruiseSettings[queryStr].data.data.config.premium;
          }
          if (cruiseSettings[queryStr].data.data.config.version > 1 || isPremium) {
             titleStr = cruiseSettings[queryStr].data.data.config.title;
          }
          tmpList.push({
            val: (i+1),
            str: titleStr,
            urlStr: url,
            isPremium: isPremium,
            version: cruiseSettings[queryStr].data.data.config.version,
            mierukaWebId: queryStr
          });
        }
      }
      this.setState({
        authzDbError: API_STATUS.OK,
        cruiseSettingError: API_STATUS.OK,
        contentsList: tmpList,
        termVerError: false
      });
    } catch (error) {
      // けどサインアウトするはずだからこれはないと思うけれど
      // mierukawebのデータが取れないときもここに来るので何か考える
      console.log('error == componentDidMount == cruiseSetting.js');
      console.log(error);
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  openUrlSnack = (param) => {
    const snackMessage = I18n.get('Link url is copied') + ':' + param;
    this.setState({
      urlSnackState: true,
      snackMessage
    });
  }
  closeUrlSnack = () => {
    this.setState({
      urlSnackState: false,
    });
  }
  async closeTermVerError (that) {
    const user = await Auth.currentAuthenticatedUser();
    const authProp = {
      user,
      href: this.state.href
    };
    that.props.authStateChange('reagreeTermsDocs', authProp);
    return;
  }

  showContentsList = () => {
    if (this.state.authzDbError === API_STATUS.LOADING) {
      return (
        <dl className="mypageUserinfoItem ">
          <dt class="mierukaItemHeader">
            <Typography variant="subheading" gutterBottom>{I18n.get('Now loading...')}</Typography>
          </dt>
        </dl>
      );
    } else if (this.state.authzDbError === API_STATUS.NO_RESPONSE) {
      // 認可DBに接続できないとき
      return (
        <dl className="mypageUserinfoItem ">
          <dt class="mierukaItemHeader">
            <Typography variant="subheading" gutterBottom>{I18n.get('Authorization check is failed.')}</Typography>
          </dt>
        </dl>
      );
    } else if (this.state.authzDbError === API_STATUS.NO_BODY) {
      // 認可DBに登録がないとき
      return (
        <dl className="mypageUserinfoItem ">
          <dt class="mierukaItemHeader">
            <Typography variant="subheading" gutterBottom>{I18n.get('You do not have registered PR contents.')}</Typography>
          </dt>
        </dl>
      );
    }
    if (this.state.cruiseSettingError === API_STATUS.NO_RESPONSE) {
      // 認可DBに登録されたMWIDに対応する巡回設定が取得できなかったとき
      // dynamoDBに存在しないケース
      return (
        <dl className="mypageUserinfoItem ">
          <dt class="mierukaItemHeader">
            <Typography variant="subheading" gutterBottom>{I18n.get("Created cruise config is not found.")}</Typography>
          </dt>
        </dl>
      );
    }
    return (
      <dl className="mypageUserinfoItem ">
        <MierukaPagenation
          content={this.state.contentsList}
          pageNationType='manage'
          openSnack={this.openUrlSnack} 
        />
      </dl>
    );
  }
  showManualLink = () => {
    if (window.LAPLACEID_LOCALE === 'en') {
      return(
        <span />
      );
    } else {
      return(
        <a href={MIERUKA_MANUAL} target='_blank' rel='noopener noreferrer'>取扱説明書はこちら</a>
      );
    }
  }
  async isTermVerError(href) {
    const authRet = await authCheck();
    return checkTermsVer(authRet.data, 'custom:agreed_term', TERM_VER, 'ver');
  }
  async controlTransition(e, href) {
    e.preventDefault();
    const ret = await this.isTermVerError();
    if (ret) {
      this.setState({
        termVerError: true,
        href
      });
      return false;
    }
    window.location.href = href;
  }
  render() {
    const destination = ENERGYMNTR_URL+"sitelist";
    return (
      <div className="mypageContainer mierukamanagement">
        <p className="mypageDescription">{I18n.get("With Mieruka Web, you can create PR content that can be viewed on the Web by measurement data of the power plant.")}{this.showManualLink()}</p>
        <p className="mypageTitle"><span class="mypageTitleIcon"></span>{I18n.get("MierukaWeb content list")}</p>
        {this.showContentsList()}
        <p className="mypageTitle"><span class="mypageTitleIcon"></span>
          {I18n.get('Free')}
        </p>
        <dl className="mypageUserinfoItem freeContentsExplanation">
          <dt class="mierukaItemHeader">
            <Typography variant="subheading" gutterBottom>
              {I18n.get('Create PR Contents(measurement, graph and explanation screen):Please press "Next" button to see the power plants list, then click "Create" button of a site you want to use. Created PR Contents is displayed to MierukaWeb content list.')}
            </Typography>
          </dt>
          <dd class="mypageUserinfoItemData">
            <a className="mypageNormalButton blue" onClick={(e) => this.controlTransition(e, destination)} href={destination}>{I18n.get('Next')}</a>
          </dd>
        </dl>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.urlSnackState}
          autoHideDuration={7000}
          onClose={this.closeUrlSnack}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={this.state.snackMessage}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={this.closeUrlSnack}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
        <LapDialog
          title={''}
          contentElem={
            <div>
              <p>{I18n.get('Terms of Service is updated.')}</p>
              <p>{I18n.get('Please reconfirm it.')}</p>
            </div>
          }
          firstButtonText={'OK'}
          firstButtonFunc={() => this.closeTermVerError(this)}
          open={this.state.termVerError}
          toClose={() => {return;}}
        />
      </div>
    );
  }
}
